module.exports = __webpack_public_path__ + "static/media/bgShare2.65565b59.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare2.png
// module id = 356
// module chunks = 0